/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-right': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M5.612 12.508h13.791M12.508 5.612l6.895 6.896-6.895 6.895" _stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
